import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {
  DevicesProfileModalContainerComponent,
} from '@clinic-platform/ui-components';

import { APP_CONFIG } from '../../../core/config/app-config.token';
import { AppConfig } from '../../../core/config/app-config.interface';
import { AuthService } from '../../../core/auth/auth.service';
import { UserRole } from '../../../core/auth/user-role.type';
import { SystemAdminContextService } from '../../../core/context/system-admin-context.service';

@Component({
  selector: 'app-device-quick-view-modal',
  standalone: true,
  imports: [DevicesProfileModalContainerComponent],
  template: `
    <lib-devices-profile-modal-container
      [isOpen]="isOpen"
      [apiBaseUrl]="apiBaseUrl"
      [deviceId]="deviceId"
      [companyId]="resolvedCompanyId"
      [role]="currentRole"
      [title]="title"
      [closeText]="'Close'"
      [showCompanyId]="false"
      [canArchive]="false"
      [canDelete]="false"
      [canEdit]="false"
      [actionsDisabled]="false"
      (close)="close.emit()"
    />
  `,
})
export class DeviceQuickViewModalComponent {
  private readonly appConfig = inject<AppConfig>(APP_CONFIG);
  private readonly authService = inject(AuthService);
  private readonly systemAdminContext = inject(SystemAdminContextService);

  @Input() public isOpen = false;
  @Input() public deviceId: string | null = null;
  @Input() public companyIdOverride: string | null = null;
  @Input() public title = 'Device Quick View';

  @Output() public readonly close = new EventEmitter<void>();

  protected get apiBaseUrl(): string {
    return this.appConfig.apiBaseUrl;
  }

  protected get currentRole(): UserRole | null {
    return (this.authService.getCurrentRole() as UserRole | null) ?? null;
  }

  protected get resolvedCompanyId(): string | null {
    const override = this.companyIdOverride?.trim() ?? '';
    if (override) {
      return override;
    }

    return this.systemAdminContext.getCompanyId()?.trim() ?? null;
  }
}
